import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useHistory, Link } from 'react-router-dom';
import './Auth.css'; // We will create this for basic styling
import AppLogo from '../assets/logo.png';

import loginBox from '../assets/loginBox.png';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login } = useAuth();
    const history = useHistory();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await login(email, password);
            history.push('/');
        } catch (err) {
            setError(err.message || 'Failed to login');
        }
    };

    return (
        <div className="auth-wrapper">
            <img src={AppLogo} alt="MythosTracker" className="auth-logo" />
            <div className="auth-container login-container">
                <form onSubmit={handleSubmit} className="auth-form login-form-specific">
                    {error && <div className="auth-error">{error}</div>}
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="auth-btn">Login</button>
                </form>
                <p>
                    Need an account? <Link to="/register">Register</Link>
                </p>
            </div>
        </div>
    );
};

export default Login;
